function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    cms-sticky-header-links-grad\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20,35.77a1.14,1.14,0,0,1-1.13-1.13V21.11a1.13,1.13,0,1,1,2.25,0V34.64A1.13,1.13,0,0,1,20,35.77Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20,36.77A2.53,2.53,0,0,1,18.21,36l-3.58-3.58a1.12,1.12,0,0,1,0-1.59,1.13,1.13,0,0,1,1.6,0l3.57,3.57a.28.28,0,0,0,.4,0l3.57-3.57a1.13,1.13,0,0,1,1.6,0,1.12,1.12,0,0,1,0,1.59L21.79,36A2.53,2.53,0,0,1,20,36.77Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20,12.7a1.79,1.79,0,0,1-.51-.07L6.78,9a1.05,1.05,0,0,1,0-2L19.46,3.27a2,2,0,0,1,1.08,0L33.22,6.94a1.05,1.05,0,0,1,0,2L20.51,12.63A1.79,1.79,0,0,1,20,12.7ZM9.66,8l10.32,3L30.34,8,20.05,5l-.34-.85L20,5Z",
  fill: "#231f20"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20,19.39a1.27,1.27,0,0,1-.72-.22,12.9,12.9,0,0,0-6.63-2.11,1.05,1.05,0,0,1-1-1V9.71a.89.89,0,1,1,1.77,0v5.61A14.92,14.92,0,0,1,20,17.52a14.92,14.92,0,0,1,6.62-2.2V9.71a.89.89,0,1,1,1.77,0V16a1.05,1.05,0,0,1-1,1,12.9,12.9,0,0,0-6.63,2.11A1.27,1.27,0,0,1,20,19.39Z",
  fill: "#231f20"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M36.08,26.32H3.92a2.78,2.78,0,0,1-2.78-2.79v-9a2.78,2.78,0,0,1,2.78-2.78H8.66a1.13,1.13,0,0,1,0,2.25H3.92a.53.53,0,0,0-.53.53v9a.53.53,0,0,0,.53.54H36.08a.54.54,0,0,0,.54-.54v-9a.54.54,0,0,0-.54-.53H31.34a1.13,1.13,0,0,1,0-2.25h4.74a2.79,2.79,0,0,1,2.79,2.78v9A2.79,2.79,0,0,1,36.08,26.32Z",
  fill: "#231f20"
});

function SvgCmsStickyHeaderLinksGrad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default SvgCmsStickyHeaderLinksGrad;